module.exports = __webpack_public_path__ + "img/acd316761ce33e8f937e2951ee22599e.jpg";